export default __webpack_public_path__ + "static/media/Toyota.bcf74255.svg";